exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kortni-jeane-fitting p[data-v-554dc98c] {\n  margin: 24px 0 0 0;\n}\n", ""]);

// exports
